var map = {
	"./add-error.svg": 6488,
	"./android.svg": 37235,
	"./apple.svg": 83232,
	"./arrow.svg": 80119,
	"./auction.svg": 3204,
	"./close-thin.svg": 45124,
	"./close.svg": 81522,
	"./demo-picture.svg": 21460,
	"./drag-icon.svg": 62343,
	"./error.svg": 69309,
	"./fair.svg": 41368,
	"./feedback.svg": 5630,
	"./highlight.svg": 94437,
	"./hint.svg": 77665,
	"./lightning.svg": 63385,
	"./paid.svg": 40477,
	"./percent.svg": 43991,
	"./premium.svg": 45423,
	"./rotate.svg": 12142,
	"./success.svg": 24089,
	"./top.svg": 19574,
	"./top3-transparent.svg": 90657,
	"./top3.svg": 60906,
	"./valid.svg": 51690,
	"./warning-black.svg": 65093,
	"./warning.svg": 3971,
	"./wp.svg": 94878,
	"./zoom.svg": 35478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51678;